import {useMemo} from 'react'
import useRouter from "./useRouter";

export default function useQuery() {
  const {search} = useRouter();

  const [, queryString = ""] = search.split("?");

  return useMemo(() => (
    queryString
      .split("&")
      .reduce((prev, curr) => {
        const [key, value] = curr.split("=");
        if (key === 'token') {
          prev.set(key, curr.replace(
            'token=',
            ''
          ))
        } else prev.set(key, value);
        return prev;
      }, new Map())
  ), [queryString])
}